import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "CasinoGameInfoWidget" */ './CasinoGameInfoWidget'),
  modules: ['./CasinoGameInfoWidget'],
  loading: () => null
});

export default LoadableWidget;
